var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83068",
    "data-name": "Group 83068",
    transform: "translate(-400 -1943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23090",
    "data-name": "Path 23090",
    d: "M1572.845,0a19,19,0,1,1-19,19,19,19,0,0,1,19-19",
    transform: "translate(-1153.845 1943)",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23091",
    "data-name": "Path 23091",
    d: "M1677.147,129.815c-2.1,0-4.18.038-6.293-.038a5.915,5.915,0,0,1-3.116-.741c-1.436-1.024-1.591-2.423-1.652-4.109-.065-1.795-.026-3.943-.033-5.762,0-1.355-.032-3.309.639-4.467a3.8,3.8,0,0,1,3.161-1.819c1.864-.191,9.325-.3,10.874.32a3.484,3.484,0,0,1,1.885,1.758c.612,1.356.505,3.523.51,5.019.005,1.713.039,4.547-.085,5.923a4.029,4.029,0,0,1-1.239,2.839,3.592,3.592,0,0,1-1.621.835,14.155,14.155,0,0,1-3.03.241m-5.288-18.894c-2.154.044-3.859.069-5.479,1.324a5.388,5.388,0,0,0-1.571,2.031,11.693,11.693,0,0,0-.622,4.578c-.018,1.742-.088,5.967.126,7.632a5.521,5.521,0,0,0,3.231,4.576,11.807,11.807,0,0,0,4.581.627c1.72.021,3.492.039,5.209,0,2.187-.046,4.042-.106,5.646-1.483a4.142,4.142,0,0,0,.346-.32c1.613-1.76,1.641-3.685,1.67-6.127.021-1.709.081-6.015-.14-7.656a6.32,6.32,0,0,0-1.061-2.83,5.457,5.457,0,0,0-2.178-1.737,12.069,12.069,0,0,0-4.6-.625c-1.7-.023-3.46-.03-5.163,0m2.558,6.925a3.463,3.463,0,1,1-2.931,5.016,3.478,3.478,0,0,1,2.931-5.016m-.119-1.869a5.335,5.335,0,1,0,.616,10.652,5.355,5.355,0,0,0,5.012-5.642,5.348,5.348,0,0,0-5.628-5.01m5.7-1.459a1.252,1.252,0,0,0-1.1,1.391,1.238,1.238,0,0,0,1.4,1.082,1.223,1.223,0,0,0,1.081-1.39,1.24,1.24,0,0,0-1.383-1.083",
    transform: "translate(-1255.161 1841.26)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/social_instagram.70305983f49cac9b20cc4bb9ce6a0cab.svg";
export { ForwardRef as ReactComponent };